import React from 'react';
import { Col, FormGroup, Row, Glyphicon } from 'react-bootstrap';
import { TextBox, TextAreaBox, CurrencyBox } from 'fw/forms';
import { Address, PhoneBox, BankingAccountTypeCombo } from "areas/shared/controls";
import { ReviewUpload } from 'areas/shared/components';
import { Label, Button } from 'fw/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import UploadsConfig from './UploadsConfig';
import { TooltipCode } from 'areas/shared/consts';

class BankInfoItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = props => {
        return {
            bankAccountsList: props.bankAccountsList,
            tooltips: props.tooltips
        };
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.bankAccountsList instanceof Array) {
            this.setState({
                bankAccountsList: nextProps.bankAccountsList
            });
        }
    }

    addEmptyPhone = (index) => {
        var item = this.state.bankAccountsList[index];

        item.phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -(Date.now() | 0)
        });

        return item;
    }

    findIndex = (key) => {
        return this.state.bankAccountsList.findIndex(function (element) {

            return element.entityId === key;
        });
    }

    onChange = (key, field, value) => {

        var index = this.findIndex(key);
        var item = this.state.bankAccountsList[index];

        if (item[field] !== value) {
            item[field] = value;
            this.props.onUpdateBankAccountsList(index, item);
        }
    }

    handleAddPhone = (key) => {
        var index = this.findIndex(key);

        var item = this.addEmptyPhone(index);
        this.props.onUpdateBankAccountsList(index, item);
    }

    handleRemovePhone = (index, phoneIndex) => {
        var item = this.state.bankAccountsList[index];

        item.phones[phoneIndex].number = "";
        item.phones.splice(phoneIndex, 1);

        this.props.onUpdateBankAccountsList(index, item);
    }

    handlePhoneChange = (value, index, phoneIndex) => {
        var item = this.state.bankAccountsList[index];

        item.phones[phoneIndex] = value;

        this.props.onUpdateBankAccountsList(index, item);
    }

    handleReviewUpload = (formUpload, baIndex) => {
        var item = this.state.bankAccountsList[baIndex];
        var items = item.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        item["reviewUploads"] = items;

        this.props.onUpdateBankAccountsList(baIndex, item);
    }

    addOtherDocument = (key) => {
        var baIndex = this.findIndex(key);

        let item = this.state.bankAccountsList[baIndex];
        let id = -Math.abs(Date.now() | 0);

        item.otherDocuments.push({
            bankingOtherDocumentId: id
        });

        this.props.onUpdateBankAccountsList(baIndex, item);
    };

    handleRemoveOtherDocument = (baIndex, docIndex) => {
        let item = this.state.bankAccountsList[baIndex];
        item.otherDocuments.splice(docIndex, 1);

        this.props.onUpdateBankAccountsList(baIndex, item);
    }

    handleDescriptionChange = (value, baIndex, docIndex) => {
        let item = this.state.bankAccountsList[baIndex];

        item.otherDocuments[docIndex].documentDescription = value;
        this.props.onUpdateBankAccountsList(baIndex, item);
    };

    handleUploadOtherDocumentChange = (formUpload, baIndex, docIndex) => {
        let item = this.state.bankAccountsList[baIndex];

        item.otherDocuments[docIndex].uploadModel = formUpload;

        this.props.onUpdateBankAccountsList(baIndex, item);
    };

    renderOtherDocuments = (key) => {
        var baIndex = this.findIndex(key);
        let me = this;
        return this.state.bankAccountsList[baIndex].otherDocuments.map((item, index) => (
            <Row key={item.bankingOtherDocumentId}>
                <Col md={12}>
                    <ReviewUpload
                        disabled={me.props.disabled}
                        reviewUpload={item.uploadModel}
                        reviewDisabled={me.props.isRenewal}
                        onChange={formUpload => this.handleUploadOtherDocumentChange(formUpload, baIndex, index)}
                        notApplicableAvailable={false}
                        queueTypeCode={this.props.queueTypeCode}
                        ref={`otherFile_${baIndex}_${index}`}
                    />
                </Col>
                <Col md={6}>
                    <Row>
                        <Col md={11}>
                            <FormGroup>
                                <TextAreaBox
                                    disabled={me.props.disabled}
                                    value={item.documentDescription}
                                    placeholder="Briefly describe your Uploaded Banking Document here..."
                                    maxLength={500}
                                    onChange={value => this.handleDescriptionChange(value, baIndex, index)}
                                    required
                                    ref={`otherFileDescription_${baIndex}_${index}`}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={1} style={{ marginTop: 10, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
                            {!me.props.disabled &&
								<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(baIndex, index)} title="Remove Bank Document">
									<FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
								</Button>
							}
                        </Col>
                    </Row>
                </Col>
            </Row>
        ));
    };

    renderPhones = (key) => {

        var index = this.findIndex(key);

        if (this.state.bankAccountsList[index].phones.length === 0) {
            this.addEmptyPhone(index);
        }

        let me = this;
        return this.state.bankAccountsList[index].phones.map((p, i) =>
            <div key={p.phoneId} className="form-inline" >
                <PhoneBox
                    required
                    disabled={me.props.disabled}
                    value={p}
                    showExtension
                    onChange={(v) => this.handlePhoneChange(v, index, i)}
                    ref={`phone_${i}`}
                />
                {!me.props.disabled && i > 0 ?
                    <Button
                        if="btnRemovePhone"
                        bsStyle="link"
                        title="Remove Phone"
                        onClick={() => this.handleRemovePhone(index, i)}><FontAwesomeIcon icon={faTimes} /></Button>
                    : null}
            </div>
        );
    }

    renderUploadFields = (baIndex) => {
        var me = this;
        return this.state.bankAccountsList[baIndex].reviewUploads.map((item, index) => (
            me.renderUploadField(item, baIndex)
        ));
    }

    renderUploadField = (reviewUpload, baIndex) => {
        const uploadKey = reviewUpload.upload.uploadKey;
        let me = this;

        return (
            <ReviewUpload
                key={uploadKey}
                disabled={me.props.disabled}
                reviewUpload={reviewUpload}
                reviewDisabled={me.props.isRenewal}
                config={UploadsConfig}
                onChange={(formUpload) => this.handleReviewUpload(formUpload, baIndex)}
                notApplicableAvailable={false}
                queueTypeCode={this.props.queueTypeCode}
                tip={me.setTip(UploadsConfig[uploadKey].tooltipCode)}>
                {uploadKey === "CancelledChecks" &&
                    <span className="small">Please combine into 1 Document - Images must include a visible signature</span>
                }
            </ReviewUpload>
        );
    }

    onRemoveBankAccount(key) {
        var index = this.findIndex(key);

        let me = this;

        me.props.removeBankAccount(index);
    }

    setTip = (property) => {
        const tooltip = this.props.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.text : null
    }

    render() {
        let me = this;
        return this.state.bankAccountsList.map((item, index) =>
            <React.Fragment key={item.entityId}>
                <Row >
                    <Col md={5}>
                        <FormGroup>
                            <Label htmlFor="financialInstitution" tip={me.setTip(TooltipCode.BANKING.FINANCIALINST)} required>Financial Institution</Label>
                            <TextBox
                                required
                                disabled={this.props.disabled}
                                name="financialInstitution"
                                value={item.financialInstitution}
                                placeholder="Financial Institution"
                                maxLength={40}
                                onChange={(value) => this.onChange(item.entityId, "financialInstitution", value)}
                                ref={`financialInstitution_${item.entityId}`} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="accountManager" tip={me.setTip(TooltipCode.BANKING.ACCOUNTMGR)} required>Account Manager</Label>
                            <TextBox
                                required
                                disabled={this.props.disabled}
                                name="accountManager"
                                value={item.accountManager}
                                placeholder="Account Manager"
                                maxLength={40}
                                onChange={(value) => this.onChange(item.entityId, "accountManager", value)}
                                ref={`accountManager_${item.entityId}`} />
                        </FormGroup>
                        <FormGroup>
                            <Address
                                name={"bankAddress" + index}
                                disabled={this.props.disabled}
                                value={item.bankAddress}
                                required
                                managed
                                onFieldChange={(value) => this.onChange(item.entityId, "bankAddress", value)}
                                ref={`bankAddress_${item.entityId}`}
                            />
                        </FormGroup>
                        {item.phones != null && item.phones.length > 0 &&
                            <FormGroup>
                                <Label htmlFor="phoneNumber" tip={me.setTip(TooltipCode.BANKING.PHONENUMBER)} required>Phone Number(s)</Label>
                                {this.renderPhones(item.entityId)}
                            </FormGroup>
                        }
                        {!this.props.disabled && item.phones != null && item.phones.length < 5 &&
                            <FormGroup>
                                <Button id="btnAddPhone" bsStyle="default" bsSize="xsmall" className="pull-right" onClick={() => this.handleAddPhone(item.entityId)}>Add Phone<Glyphicon glyph="plus" style={{ marginLeft: 10 }} /></Button>
                            </FormGroup>
                        }
                    </Col>
                    <Col md={1}></Col>
                    <Col md={5}>
                        <FormGroup>
                            <Label htmlFor="bankApprovedCreditLine" tip={me.setTip(TooltipCode.BANKING.BANKAPPROVEDCL)} required>Bank Approved Credit Line</Label>
                            <CurrencyBox
                                managed
                                required
                                disabled={this.props.disabled}
                                value={item.bankApprovedCreditLine}
                                name="bankApprovedCreditLine"
                                placeholder="Bank Approved Credit Line"
                                positiveNumbersOnly
                                precision={0}
                                onFieldChange={(value) => this.onChange(item.entityId, "bankApprovedCreditLine", value)}
                                ref={`bankApprovedCreditLine_${item.entityId}`}
                                maxLength={10} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="bankingAccountTypeId" tip={me.setTip(TooltipCode.BANKING.TYPEBANKACCOUNT)} required>Type of Bank Account</Label>
                            <BankingAccountTypeCombo
                                required
                                disabled={this.props.disabled}
                                value={item.bankingAccountTypeId}
                                name="bankingAccountTypeId"
                                ref={`bankingAccountTypeId_${item.entityId}`}
                                onChange={(value) => this.onChange(item.entityId, "bankingAccountTypeId", value.value)}
                                placeholder="Type of Bank Account" />
                        </FormGroup>
                    </Col>
                    <Col md={2}></Col>
                    <Col md={10}>
                        <Row>
                            <Col md={12}>
                                {this.renderUploadFields(index)}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                {item.otherDocuments != null && item.otherDocuments.length > 0 && (
                                    <React.Fragment>
                                        {this.renderOtherDocuments(item.entityId)}
                                    </React.Fragment>
                                )}
                                {!this.props.disabled && (item.otherDocuments == null || item.otherDocuments.length < 5) &&
									<Button type="button" bsStyle="link" onClick={() => this.addOtherDocument(item.entityId)}>
										Add another Bank Document
									</Button>
								}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <input type="hidden" name="rowVersion" value={item.rowVersion} />
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <br /><br />
                            {!this.props.disabled && index === this.state.bankAccountsList.length - 1 ? (
                                <Button id="addBankAccount" bsSize='xsmall' onClick={() => this.props.addBankAccount(this.state.bankAccountsList.length)}>Add another Bank Account</Button>
                            ) : null}
                            &nbsp;&nbsp;
                            {!this.props.disabled && index > 0 ? (
                                <Button id="removeBankAccount" bsSize='xsmall' onClick={() => me.onRemoveBankAccount(item.entityId)}>Remove Bank Account</Button>
                            ) : null}
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment >
        );
    }

}

export default BankInfoItem;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/bankInfo/BankInfoItem.js